export const vaultConstant = {
  providerName: "Provider Name",
  id: "Id",
  createdData: "Created Date",
  providerLabel: "Enter Provider Name",
  usernameLabel: "Enter Username",
  add: "Add",
  update: "Update",
  passwordType: [
    { label: "Password", value: "password" },
    { label: "Site", value: "site" },
    { label: "Other", value: "other" },
  ],
  type: "Type",
  notes: "Notes",
  url: "URL",
  urlPlaceholder: "Enter URL",
  SAVE: "Save",
  permissionUpdateSuccess:"Permission updated successfully",
  select:"Select",
  readOnly:"Read Only",
  readWrite:"Read & Write",
  manage:"Manage",
  create:"Create",
  createPassword:"Add Password",
  passwordInformation:"Password Information"
};
